import { render, staticRenderFns } from "./TraxAccountRoleEditPermissions.vue?vue&type=template&id=83712408"
import script from "./TraxAccountRoleEditPermissions.vue?vue&type=script&lang=js"
export * from "./TraxAccountRoleEditPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports